import styled from '@emotion/styled';
import { memo } from 'react';
import { proxy, useSnapshot } from 'valtio';
import { fill_horizontal_all_center, fill_vertical_cross_center, jc, } from '~/modules/AppLayout/FlexGridCss';
import { Button, Tabs } from '@mantine/core';
import { css } from '@emotion/react';
import { useStockPriceChangeDistributionState } from '../futuresai/stock-price-change-distribution/components/useStockPriceChangeDistributionState';
import { TbSwitchVertical, TbViewfinder } from 'react-icons/tb';
import { HiFire } from 'react-icons/hi';
import { BsGrid1X2 } from 'react-icons/bs';
import { StockGroup } from './component/StockGroup';
import { StockPopular } from './component/StockPopular';
import { StockPick } from './component/StockPick';
import { wu5868_strategiesDayTradeGroup } from './wu5868_initStrategies';
import { store } from '../heineken_template/_private/store';
import { StockSignal } from './component/StockSignal';
import { StockFirebaseLong } from './component/StockFirebaseLong';
import { FaHandHoldingUsd } from 'react-icons/fa';
import { StockHolding } from './component/StockHolding';
import { StockFirebaseShort } from './component/StockFirebaseShort';
import { AiOutlineFall, AiOutlineRise } from 'react-icons/ai';
export const wu5868_store = proxy({
    tradeDate: '',
});
export const Wu5868_SidePane2 = memo(function Wu5868_SidePane2(props) {
    const charting = useSnapshot(store.charting);
    return (<styleds.container>
      <styleds.indicatorsGroup>
        {wu5868_strategiesDayTradeGroup.main.map(config => {
            const isActive = charting.strategySelected.displayName === config.displayName;
            return (<Button css={css `
                width: 100%;
              `} compact key={config.displayName} variant='gradient' gradient={isActive
                    ? { from: 'red', to: 'pink', deg: 119 }
                    : { from: 'gray', to: 'gray', deg: 212 }} onClick={event => {
                    store.charting.setStrategy(config);
                    store.charting.updateFromStrategyState();
                }}>
              {config.displayName}
            </Button>);
        })}
      </styleds.indicatorsGroup>
      <Tabs defaultValue='gallery' css={css `
          ${fill_vertical_cross_center};
          height: calc(100% - 36px);
          gap: 4px;
        `}>
        <Tabs.List css={css `
            width: 100%;
            height: 80px;
            box-shadow: 1px 0px 4px 1px #cacaca;
            border-radius: 4px;
            padding: 4px;
          `}>
          <Tabs.Tab value='gallery' icon={<TbViewfinder size='0.8rem'/>}>
            選股
          </Tabs.Tab>
          <Tabs.Tab value='signal' icon={<TbSwitchVertical size='0.8rem'/>}>
            訊號
          </Tabs.Tab>
          <Tabs.Tab value='messages' icon={<HiFire size='0.8rem'/>}>
            熱門股
          </Tabs.Tab>
          <Tabs.Tab value='settings' icon={<BsGrid1X2 size='0.8rem'/>}>
            族群
          </Tabs.Tab>
          <Tabs.Tab value='master-long' icon={<AiOutlineRise size='0.8rem'/>}>
            大師(多)
          </Tabs.Tab>
          <Tabs.Tab value='master-short' icon={<AiOutlineFall size='0.8rem'/>}>
            大師(空)
          </Tabs.Tab>
          <Tabs.Tab value='holding' icon={<FaHandHoldingUsd size='0.8rem'/>}>
            持有
          </Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value='gallery' css={css `
            width: 100%;
            height: calc(100% - 86px);
          `}>
          <StockPick />
        </Tabs.Panel>

        <Tabs.Panel value='signal' css={css `
            width: 100%;
            height: calc(100% - 86px);
          `}>
          <StockSignal />
        </Tabs.Panel>

        <Tabs.Panel value='messages' css={css `
            width: 100%;
            height: calc(100% - 86px);
          `}>
          <StockPopular />
        </Tabs.Panel>

        <Tabs.Panel value='settings' css={css `
            height: calc(100% - 86px);
          `}>
          <useStockPriceChangeDistributionState.Provider>
            <StockGroup />
          </useStockPriceChangeDistributionState.Provider>
        </Tabs.Panel>

        <Tabs.Panel value='master-long' css={css `
            width: 100%;
            height: calc(100% - 86px);
          `}>
          <StockFirebaseLong />
        </Tabs.Panel>

        <Tabs.Panel value='master-short' css={css `
            width: 100%;
            height: calc(100% - 86px);
          `}>
          <StockFirebaseShort />
        </Tabs.Panel>

        <Tabs.Panel value='holding' css={css `
            width: 100%;
            height: calc(100% - 86px);
          `}>
          <StockHolding />
        </Tabs.Panel>
      </Tabs>
    </styleds.container>);
});
const styleds = {
    container: styled.div `
    ${fill_vertical_cross_center};
    background-color: #fafafa;
    padding: 4px;
    border-right: 1px solid #aaaaaa;
    gap: 4px;
  `,
    indicatorsGroup: styled.div `
    ${fill_horizontal_all_center};
    ${jc.spaceEvenly};
    height: 30px;
    gap: 8px;
  `,
    indicator: styled.div `
    border: 1px solid ${props => (props.isActive ? '#252525' : 'transparent')};
    padding: 0 4px;
    border-radius: 2px;
  `,
};
